import { Box, Container, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
import EditOperationForm from './EditOperationForm'

import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'

export const RecettesCategory = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const [operations, setOperations] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  const [selected, setSelected] = useState(false)

  useEffect(() => {
    fetchOperations()
  }, [])

  const fetchOperations = async (pagination = '') => {
    let url = `${urls.crudRecettesCategoryOperations}`

    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
    }
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkCategoryOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }

  return (
    <>
      <Box bgcolor={'#001b42'} p={1}>
        <AppBar
          sx={{
            position: 'relative',
            backgroundColor: theme.palette.appBar.top,
          }}
        >
          <Toolbar sx={{ ':hover': { cursor: 'pointer' } }} onClick={() => navigate('/recette')}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => navigate('/recette')}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Gestion des catégories
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>

      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            <CreateOperationForm setOperations={setOperations} />
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  setSelectedRowsParams({
                    ...operations.results.filter((v) => v.id === selectedRows[0]),
                  })
                  setSelected(true)
                } else {
                  setSelected(false)
                  alert('Please Select one category for modifier')
                }
              }}
            >
              Modifier
            </CustomButton>
            {selected ? (
              <EditOperationForm
                setOperations={setOperations}
                setSelected={setSelected}
                params={selectedRowsParams}
                operations={operations}
              />
            ) : (
              ''
            )}

            <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
          </Box>
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
    </>
  )
}
